import { Avatar, Box, Tooltip, Typography } from '@mui/material'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'
import React, { useState } from 'react'
import { DensityStyleTypes, Task } from 'types'
import { stringAvatar } from '../DataGrid/gridOperators'

type params = {
  value: string
}

interface TaskGridOrgsProps {
  params: GridRenderCellParams
  onClickOrganization: (PK: string) => void
  photoUrl: string
  densityStyles: DensityStyleTypes
  orgName: string
  onTaskClick: (_: any, taskData: Task) => void
}

const TaskGridOrgs: React.FC<TaskGridOrgsProps> = ({
  params,
  onClickOrganization,
  photoUrl,
  densityStyles,
  orgName,
  onTaskClick,
}) => {
  const [isHovered, setIsHovered] = useState<boolean>(false)
  const { PK } = params?.row ?? {}

  return (
    <Box
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        padding: densityStyles.padding,
        gap: densityStyles.gap,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
          fontWeight: 'bold',
          cursor: 'pointer',
          padding: densityStyles.padding,
          gap: densityStyles.gap,
        }}
        // onClick={() => onClickOrganization(PK)}
        onClick={event => onTaskClick(event, params?.row)}
      >
        {isHovered ? (
          <Typography
            sx={{
              fontSize: densityStyles.fontSize,
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              textAlign: 'left',
              width: '100%',
              height: '100%',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            {orgName}
          </Typography>
        ) : (
          <Tooltip title={params?.value}>
            {photoUrl ? (
              <Avatar
                src={photoUrl}
                sx={{
                  width: densityStyles.avatarSize,
                  height: densityStyles.avatarSize,
                  objectFit: 'cover',
                  objectPosition: 'center',
                }}
                alt={orgName}
              />
            ) : (
              <Avatar
                {...stringAvatar(orgName, densityStyles)}
                sx={{
                  backgroundColor: 'rgb(114, 229, 218)',
                  width: densityStyles.avatarSize,
                  height: densityStyles.avatarSize,
                  objectFit: 'cover',
                  objectPosition: 'center',
                }}
              />
            )}
          </Tooltip>
        )}
      </Box>
    </Box>
  )
}

export default TaskGridOrgs
